import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Protected from "@/components/Protected";
import Landing from "@/pages/Landing";
import Pricing from "@/pages/Pricing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import VerifyEmail from "@/pages/VerifyEmail";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Scripts from "@/pages/Scripts";
import NewWorkspaceRedirect from "@/pages/NewWorkspaceRedirect";
import Workspace from "@/pages/Workspace";
import Account from "@/pages/Account";
import BillingSuccess from "@/pages/BillingSuccess";
import Terms from "@/pages/Terms";
import Imprint from "@/pages/Imprint";
import Privacy from "@/pages/Privacy";
import Cancellation from "@/pages/Cancellation";
import CancellationForm from "@/pages/CancellationForm";
import AdminUsers from "@/pages/AdminUsers";
import AdminProfitability from "@/pages/AdminProfitability";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/generate" element={<Protected><NewWorkspaceRedirect /></Protected>} />
            <Route path="/scripts" element={<Protected><Scripts /></Protected>} />
            {/* Phase 2.1P-FINAL — /scripts/:id and /workspace/:id both
               serve the Beam-AI Workspace natively. Deep links remain
               stable under either prefix so any bookmarked URLs still
               resolve without redirects. */}
            <Route path="/scripts/:id" element={<Protected><Workspace /></Protected>} />
            <Route path="/workspace/:id" element={<Protected><Workspace /></Protected>} />
            <Route path="/account" element={<Protected><Account /></Protected>} />
            <Route path="/billing/success" element={<Protected><BillingSuccess /></Protected>} />
            {/* Legal pages — public, no auth required. */}
            <Route path="/terms" element={<Terms />} />
            <Route path="/imprint" element={<Imprint />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cancellation" element={<Cancellation />} />
            <Route path="/cancellation-form" element={<CancellationForm />} />
            {/* Admin — backend enforces access; frontend only hides the nav link. */}
            <Route path="/admin/users" element={<Protected><AdminUsers /></Protected>} />
            <Route path="/admin/profitability" element={<Protected><AdminProfitability /></Protected>} />
          </Routes>
        </Layout>
        <Toaster position="top-right" theme="dark" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
